import * as React from "react";
import { withRouter } from "react-router-dom";

import { HeaderGlobalAction } from "carbon-components-react";
import {
  Catalog20,
  Collaborate20,
  Document20,
  Flag20,
  Forum20,
  ListChecked20,
  Task20,
} from "@carbon/icons-react";

import { Screen, ToolPanelEnum, screenIsActive, screenUrl } from "./shared";

interface IProps {
  appId: number;
  panelOpenTo: null | ToolPanelEnum;
  togglePanelOpenTo: Function;

  // withRouter
  history: any;
  location: any;
  match: any;
}

const Tools = ({ appId, panelOpenTo, togglePanelOpenTo, history, location }: IProps) => (
  <>
    {/* just links */}
    <HeaderGlobalAction
      aria-label={Screen.Messages}
      title={Screen.Messages}
      isActive={screenIsActive(location, Screen.Messages)}
      onClick={() => history.push(screenUrl(appId, Screen.Messages))}
      style={{ justifyContent: "center" }}
    >
      <Forum20 />
    </HeaderGlobalAction>
    <HeaderGlobalAction
      aria-label={Screen.Documents}
      title={Screen.Documents}
      isActive={screenIsActive(location, Screen.Documents)}
      onClick={() => history.push(screenUrl(appId, Screen.Documents))}
      style={{ justifyContent: "center" }}
    >
      <Document20 />
    </HeaderGlobalAction>

    {/* toggle panels */}
    <HeaderGlobalAction
      aria-label={ToolPanelEnum.Notes}
      title={ToolPanelEnum.Notes}
      isActive={panelOpenTo === ToolPanelEnum.Notes}
      onClick={() => togglePanelOpenTo(ToolPanelEnum.Notes)}
      style={{ justifyContent: "center" }}
    >
      <Catalog20 />
    </HeaderGlobalAction>
    <HeaderGlobalAction
      aria-label={ToolPanelEnum.Conditions}
      title={ToolPanelEnum.Conditions}
      isActive={panelOpenTo === ToolPanelEnum.Conditions}
      onClick={() => togglePanelOpenTo(ToolPanelEnum.Conditions)}
      style={{ justifyContent: "center" }}
    >
      <ListChecked20 />
    </HeaderGlobalAction>
    <HeaderGlobalAction
      aria-label={ToolPanelEnum.Flags}
      title={ToolPanelEnum.Flags}
      isActive={panelOpenTo === ToolPanelEnum.Flags}
      onClick={() => togglePanelOpenTo(ToolPanelEnum.Flags)}
      style={{ justifyContent: "center" }}
    >
      <Flag20 />
    </HeaderGlobalAction>

    {/* more links */}
    <HeaderGlobalAction
      aria-label={Screen.Tasks}
      title={Screen.Tasks}
      isActive={screenIsActive(location, Screen.Tasks)}
      onClick={() => history.push(screenUrl(appId, Screen.Tasks))}
      style={{ justifyContent: "center" }}
    >
      <Task20 />
    </HeaderGlobalAction>
    <HeaderGlobalAction
      aria-label={Screen.ContactInfo}
      title={Screen.ContactInfo}
      isActive={screenIsActive(location, Screen.ContactInfo)}
      onClick={() => history.push(screenUrl(appId, Screen.ContactInfo))}
      style={{ justifyContent: "center" }}
    >
      <Collaborate20 />
    </HeaderGlobalAction>
  </>
);

export default withRouter(Tools);
